import "./footer.css";
export const Footer = () => {
  return (
    <div className="footer">
      <span>© {new Date().getFullYear()} | Powered by Aleksandar Lilov</span>
    </div>
  );
};
